/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { UpdateOrganizationMutationRequest, UpdateOrganizationMutationResponse, UpdateOrganizationPathParams, UpdateOrganization400, UpdateOrganization401, UpdateOrganization403, UpdateOrganization404, UpdateOrganization409, UpdateOrganization500 } from "../../types/organizationController/UpdateOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateOrganization } from "../../client/organizationController/updateOrganization.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateOrganizationMutationKey = () => [{ url: '/api/organizations/:organizationId' }] as const

export type UpdateOrganizationMutationKey = ReturnType<typeof updateOrganizationMutationKey>

export function updateOrganizationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateOrganizationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateOrganizationMutationKey()
        return mutationOptions<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, {organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, data }) => {
            return updateOrganization(organizationId, data, config)
          },
        })

}

/**
 * @summary Update organization
 * {@link /api/organizations/:organizationId}
 */
export function useUpdateOrganization<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, {organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateOrganizationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateOrganizationMutationKey()

          const baseOptions = updateOrganizationMutationOptions(config) as UseMutationOptions<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, {organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest}, TContext>
          

          return useMutation<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, {organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, {organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest}, TContext>
      
}